const transfers = {
  transfer: "Pemindahan", // translated 
  transfers: "Pemindahan", // translated 
  dateAndTime: "Tarikh dan Masa", // translated 
  transferFrom: "Pindahkan Dari", // translated 
  duration: "Tempoh", // translated 
  numOfPersons: "Bilangan Orang", // translated 
  baggageAllowance: "Elaun Bagasi", // translated 
  small: "Kecil", // translated 
  big: "Besar", // translated 
  provider: "Pembekal", // translated 
  vehicle: "Kenderaan", // translated 
  distance: "Jarak", // translated 
  price: "Harga", // translated 
  inboundJourney: "Perjalanan Masuk", // translated 
  outboundJourney: "Perjalanan Keluar", // translated 
  arrivalTime: "Masa Ketibaan", // translated 
  flightDetails: "Butiran Penerbangan", // translated 
  inboundPickupDate: "Tarikh Pengambilan Masuk", // translated 
  outboundPickupDate: "Tarikh Pengambilan Keluar", // translated 
  travelInfo: "Maklumat Perjalanan", // translated 
  travellersInformation: "Maklumat Pelancong", // translated 
  flightsInfo: "Maklumat Penerbangan", // translated 
  airportYouAreFlyingFrom: "Lapangan terbang tempat anda terbang", // translated 
  airportYouAreFlyingTo: "Lapangan terbang yang anda naiki", // translated 
  inboundFlightNumber: "Nombor Penerbangan Masuk", // translated 
  outboundFlightNumber: "Nombor Penerbangan Keluar", // translated 
  inboundAirlineName: "Nama Syarikat Penerbangan Masuk", // translated 
  outboundAirlineName: "Nama Syarikat Penerbangan Keluar", // translated 
  tripMode: "Mod Perjalanan", // translated 
  airportToPoint: "Lapangan Terbang Ke Titik", // translated 
  pointToAirport: "Point To Airport", // translated 
  roundTrip: "Perjalanan Pergi Balik", // translated 
  destinationPoint: "Titik Destinasi", // translated 
  originPoint: "Titik Asal", // translated 
  transferType: "Jenis Pemindahan", // translated 
  min: "Min", // translated 
  max: "Maks", // translated 
  pieces: "Kepingan", // translated 
  cancelationIs: "pembatalan adalah", // translated 
};






export default transfers;
